/* Otaku Dreams helpers.
   Dawn's reveal animation leaves a transform on the product info column, which
   traps position:fixed descendants. Anything marked .od-move-to-body is re-parented
   to <body> once, so sticky bars and modals render relative to the viewport. */
(function () {
  function relocate() {
    document.querySelectorAll('.od-move-to-body').forEach(function (el) {
      if (el.parentElement === document.body) return;
      document.body.appendChild(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocate);
  } else {
    relocate();
  }
  // Theme editor re-renders sections; relocate again after each load.
  document.addEventListener('shopify:section:load', relocate);
  document.addEventListener('shopify:block:select', relocate);
})();
